import { observer } from "mobx-react";
import ContentState from "../../../../stores/ContentState";
import H2 from "../H2";
import MissionImage from "../MissionImage";
import "./index.scss";
import P18 from "../P18";
import H3 from "../H3";
import { ReactComponent as ArrowLeft } from "../../../../assets/arrow-left.svg";
import AnimatedBlock from "../AnimatedBlock";

const DreamTeam = () => {
  const { team } = ContentState.mission;
  return (
    <section className="mission-team">
      <H2 text={team?.title} />
      <AnimatedBlock>
        <div className="culturedesc">
          <MissionImage src={team?.src} />
        </div>
        <div className="culturemodi">
          <MissionImage src={team?.srcMobi} />
        </div>
        
      </AnimatedBlock>
      <div className="mission-team__container">
        <AnimatedBlock>
          <P18 text={team?.text} />
        </AnimatedBlock>
        <div
          className="mission-team__content"
          // dangerouslySetInnerHTML={{ __html: team?.content }}
        >
          {team?.content?.map((c: any, i: number) => (
            <AnimatedBlock key={i}>
              <h3 dangerouslySetInnerHTML={{ __html: c.title }}></h3>
              <p dangerouslySetInnerHTML={{ __html: c.text }}></p>
            </AnimatedBlock>
          ))}
        </div>
        <AnimatedBlock>
          <div className="mission-team__row">
            <div className="culturedesc">
              <MissionImage src={team?.block?.src} />
            </div>
            <div className="culturemodi">
              <MissionImage src={team?.block?.srcMobi} />
            </div>
            <div className="mission-team__col">
              {team?.block?.list?.map((c: any, i: number) => (
                <div className="mission-team__item" key={i}>
                  <P18 text={c?.title} />
                  <span className="mission-team__item-subtitle">{c.text}</span>
                </div>
              ))}
            </div>
          </div>
        </AnimatedBlock>
        <AnimatedBlock>
          <div className="mission-team__bottom">
            <H3 text={team?.block?.text} />
          </div>
        </AnimatedBlock>
      </div>
      <div
        className="team__bottom-arrow"
        onClick={() => {
          window.scrollTo(0, 0);
        }}
      >
        <ArrowLeft />
      </div>
    </section>
  );
};

export default observer(DreamTeam);
